import styled from 'styled-components';

export const StyledCustomInputBox = styled.div`
  &.WLInputBox {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    z-index: 2;
    background: black;
    padding: 10px;
    box-shadow: 1px 2px 2px grey;
    box-sizing: border-box;

    @media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
      background-color: rgba(0, 0, 0, 0.8);
    }
  }

  &.MPRThicknessInputBox {
    width: fit-content;
    position: absolute;
    display: flex;
    flex-direction: column;
    z-index: 2;
    background: black;
    padding: 10px;
    box-shadow: 1px 2px 2px grey;

    @media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
      position: fixed;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 99999999;
      display: flex;
      align-items: center;
      overflow-y: auto;
      background-color: rgba(0, 0, 0, 0.8);
    }
  }
`;

export const CloseButton = styled.div`
  align-self: flex-end;
  cursor: pointer;
  color: white;
  z-index: 3;
  padding: 10px;
`;
